import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import { CruiseContentSections, CRUISE_CONTENT_SECTION_LABELS } from 'constants/cruise'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import AboutTheShip from './AboutTheShip'
import CruiseDecksAndCabins from '../DecksAndCabins/CruiseDecksAndCabins'
import CruiseFinePrint from '../FinePrint/CruiseFinePrint'

const SectionContainer = styled(LayoutContainer)`
  padding-bottom: ${rem(32)};
  padding-top: ${rem(32)};
`

interface Props {
  offer: App.CruiseOffer;
  contentSections: Set<CruiseContentSections>;
  hasGotToTabs: boolean;
  scrollToPackageOptions: (id: string) => void;
}

function CruiseOfferPageAboutShip({
  offer,
  contentSections,
  hasGotToTabs,
  scrollToPackageOptions,
}: Props) {
  const { finePrint } = offer
  return <>
    <Pane>
      <SectionContainer>
        <Group direction="vertical" gap={48}>
          <Heading
            align="center"
            variant="heading2"
            className="section-title"
          >About the ship</Heading>
          <div className="section-content"><AboutTheShip offer={offer} /></div>
        </Group>
      </SectionContainer>
    </Pane>

    {contentSections.has(CruiseContentSections.DECKS_AND_CABINS) && (
      <Pane>
        <SectionContainer>
          <Group direction="vertical" gap={48}>
            <Heading
              align="center"
              variant="heading2"
              className="section-title"
            >{CRUISE_CONTENT_SECTION_LABELS[CruiseContentSections.DECKS_AND_CABINS]}</Heading>

            <div className="section-content">
              <CruiseDecksAndCabins
                ship={offer.ship}
                hasGotToOverview={hasGotToTabs}
                showPackageOptions={() => scrollToPackageOptions('dates-and-pricing')} />
            </div>
          </Group>
        </SectionContainer>
      </Pane>
    )}

    {!!finePrint && contentSections.has(CruiseContentSections.FINE_PRINT) && (
      <Pane>
        <SectionContainer size="md">
          <Heading
            align="center"
            variant="heading2"
            className="section-title"
          >{CRUISE_CONTENT_SECTION_LABELS[CruiseContentSections.FINE_PRINT]}</Heading>
          <div className="section-content"><CruiseFinePrint finePrint={finePrint} /></div>
        </SectionContainer>
      </Pane>
    )}
  </>
}

export default CruiseOfferPageAboutShip
